// extracted by mini-css-extract-plugin
export default {"profile_page":"Profile_profile_page__HZCaq","player_overview":"Profile_player_overview__3UUou","player_content":"Profile_player_content__wvxd6"};